module.exports = "/_next/static/images/a2ca5c0a87f6edcbbb49221a2584c510-instant-pay-xs.png.webp";